import { hasFinePointer } from "./gsap";

/**
 * Cursor spotlight: panels near the pointer get `--mx` / `--my` (pointer position in their
 * own box) which their CSS turns into a soft accent glow. Works for every element
 * matching `selector`; elements added later are picked up on the next move.
 */
export const SPOTLIGHT_SELECTOR = [
  ".home-object",
  ".value-card",
  ".faq-item",
  ".compare-card",
  ".process-step",
  ".quote-card",
  ".price-card",
  ".contact-card",
  ".feature",
  ".stat",
  ".tool",
  ".tester-box",
  ".calc",
].join(",");

type Lit = HTMLElement & { __lit?: boolean };

export function initSpotlight(selector = SPOTLIGHT_SELECTOR): () => void {
  if (!hasFinePointer()) return () => {};
  const ac = new AbortController();
  let pending: PointerEvent | null = null;
  let raf = 0;

  const apply = () => {
    raf = 0;
    const e = pending;
    if (!e) return;
    const objs = document.querySelectorAll<Lit>(selector);
    for (const o of objs) {
      const r = o.getBoundingClientRect();
      const inside = e.clientX > r.left - 140 && e.clientX < r.right + 140 && e.clientY > r.top - 140 && e.clientY < r.bottom + 140;
      if (inside) {
        o.style.setProperty("--mx", e.clientX - r.left + "px");
        o.style.setProperty("--my", e.clientY - r.top + "px");
      } else if (o.__lit) {
        o.style.setProperty("--mx", "-999px");
        o.style.setProperty("--my", "-999px");
      }
      o.__lit = inside;
    }
  };

  window.addEventListener(
    "pointermove",
    (e) => {
      pending = e;
      if (!raf) raf = window.requestAnimationFrame(apply);
    },
    { passive: true, signal: ac.signal }
  );

  return () => {
    ac.abort();
    if (raf) window.cancelAnimationFrame(raf);
  };
}
